export default __webpack_public_path__ + "slices/main/assets/public/media/social/culture-amp-thumb-1@2x.a25d488b79a5e2b550c43ea7fb720c7f.png";